class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").deleteQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
      document.getElementById('offcanvas__mini_cart').classList.add('loading-bar');
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );
    
    // Flag to prevent infinite loops when applying rewards
    this.isApplyingRewards = false;
 
    this.emptyCartItem = document.getElementById("min-cart-items");
    this.cartItemMessageShow = document.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = document.getElementById("empty__cart__button");
    this.emptyCartHeader =  document.querySelector(".cart-notification__header"); 

    this.cartAddSuccess = document.querySelector(".item__success_message ");
    this.cartEmptyHead = document.querySelector(".item__empty_message");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    // Flags to prevent concurrent operations
    this.isRemovingRewards = false;
    this.youllLoveTheseInitialized = false;

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    
    // Add click handler for .deneme button
    this.setupDenemeButton();
    
    // Initialize You'll Love These on page load if cart drawer is present
    // Use setTimeout to ensure DOM is fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          console.log('🔧 Calling #initYoullLoveThese from DOMContentLoaded');
          this.#initYoullLoveThese();
        }, 300);
      });
    } else {
      // DOM already loaded
      setTimeout(() => {
        console.log('🔧 Calling #initYoullLoveThese from constructor (DOM ready)');
        this.#initYoullLoveThese();
      }, 300);
    }
  }
  
  setupDenemeButton() {
    // Use event delegation on the cart container
    // This works even if the button is dynamically added
    if (this.cartItemConatiner) {
      this.cartItemConatiner.addEventListener('click', async (event) => {
        if (event.target.classList.contains('deneme')) {
          event.preventDefault();
          event.stopPropagation();
          await this.updateCartNotificationProduct();
        }
      });
    }
  }

  async updateCartNotificationProduct() {
    if (!this.cartItemConatiner) {
      console.error('Cart notification product container not found');
      return;
    }
    
    try {
      // Fetch cart view with soner template
      const response = await fetch('/cart?view=soner', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      });
      
      if (!response.ok) {
        console.error('Error fetching cart view:', response.status);
        return;
      }
      
      const html = await response.text();
      
      // Parse HTML and extract cart-notification-product content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartProductElement = doc.getElementById('cart-notification-product');
      
      if (cartProductElement) {
        // Update cart notification count in header
        const cartCountElement = doc.getElementById('cart-notification-count');
        if (cartCountElement) {
          const count = parseInt(cartCountElement.textContent) || 0;
          this.#updateCartNotificationCount(count);
        }
        
        // Update cart total
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        await this.#updateCartTotal(cart);
        
        // Update the innerHTML
        this.cartItemConatiner.innerHTML = cartProductElement.innerHTML;
        
        // Update savings
        await this.#updateCartSavings();
      } else {
        // Fallback: try to get all cart-notification-product elements
        const cartProductElements = doc.querySelectorAll('.cart-notification-product');
        if (cartProductElements.length > 0) {
          // Combine all cart items
          let combinedHTML = '';
          cartProductElements.forEach(element => {
            combinedHTML += element.outerHTML;
          });
          this.cartItemConatiner.innerHTML = combinedHTML;
          
          // Add free shipping item if achieved (after cart items are rendered)
          setTimeout(() => {
            // Get current achieved rewards
            const progressContainer = document.querySelector('.cart-free-shipping-progress');
            if (progressContainer) {
              const rewards = this.#parseRewardsFromDOM(progressContainer);
              // Calculate current total
              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  const totalWithoutRewards = cart.items
                    .filter(item => !(item.properties && (item.properties._reward === 'true' || item.properties._gift === 'true')))
                    .reduce((sum, item) => sum + item.final_line_price, 0);
                  const achievedRewards = rewards.filter(r => r.threshold <= totalWithoutRewards);
                  this.#updateFreeShippingCartItem(achievedRewards);
                })
                .catch(err => console.error('Error checking free shipping:', err));
            }
          }, 200);
        } else {
          console.error('Cart notification product element not found in response');
          // If cart is empty, clear the container
          this.cartItemConatiner.innerHTML = '';
        }
      }
      
    } catch (error) {
      console.error('Error updating cart notification product:', error);
    }
  }

  async #addFreeShippingItemToCart() {
    console.log('🚚 #addFreeShippingItemToCart called');
    
    // Check if feature is enabled
    const progressContainer = document.querySelector('.cart-free-shipping-progress');
    if (!progressContainer) {
      console.log('🚚 Progress container not found');
      return;
    }
    
    const showAsCartItem = progressContainer.dataset.showAsCartItem === 'true';
    console.log('🚚 showAsCartItem:', showAsCartItem, 'dataset:', progressContainer.dataset.showAsCartItem);
    
    if (!showAsCartItem) {
      console.log('🚚 Feature disabled in settings');
      return;
    }
    
    try {
      // Get cart and calculate total without rewards
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const totalWithoutRewards = cart.items
        .filter(item => {
          if (!item.properties) return true;
          const hasReward = item.properties._reward === 'true';
          const hasGift = item.properties._gift === 'true';
          return !(hasReward || hasGift);
        })
        .reduce((sum, item) => sum + item.final_line_price, 0);
      
      console.log('🚚 Total without rewards:', totalWithoutRewards);
      
      // Get rewards
      const rewards = this.#parseRewardsFromDOM(progressContainer);
      console.log('🚚 All rewards:', rewards);
      
      // Find achieved free shipping reward
      const freeShippingReward = rewards.find(r => 
        r.type === 'free_shipping' && 
        r.threshold <= totalWithoutRewards
      );
      
      console.log('🚚 Free shipping reward found:', freeShippingReward);
      
      if (!freeShippingReward) {
        console.log('🚚 No free shipping reward achieved');
        return;
      }
    
    // Build free shipping item HTML
    const rewardElement = freeShippingReward.element;
    if (!rewardElement) return;
    
    const rewardTextEl = rewardElement.querySelector('.free-shipping-reward__text');
    const rewardText = rewardTextEl ? rewardTextEl.textContent.trim() : 'Free Shipping';
    
    const iconType = rewardElement.dataset.iconType || 'emoji';
    const iconEmoji = rewardElement.dataset.iconEmoji || '🚚';
    const iconUrl = rewardElement.dataset.iconUrl || '';
    
    // Build icon HTML
    let iconHTML = '';
    if (iconType === 'emoji') {
      iconHTML = `<span style="font-size: 48px; display: flex; align-items: center; justify-content: center; width: 120px; height: 120px;">${iconEmoji}</span>`;
    } else if (iconType === 'custom_url' && iconUrl) {
      iconHTML = `<img class="cart-notification-product__image" src="${iconUrl}" alt="${rewardText}" width="120" height="120" loading="lazy" draggable="false">`;
    } else {
      iconHTML = `<span style="font-size: 48px; display: flex; align-items: center; justify-content: center; width: 120px; height: 120px;">🚚</span>`;
    }
    
    const freeShippingHTML = `
<div class=" cart-items cart-notification-product" data-reward-type="free_shipping">
  <div class="loading-overlay hidden">
    <div class="loading-overlay__spinner">
      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
  </div>

  <span class="cart-notification__product--image">
    ${iconHTML}
  </span>

  <div class="cart-notification-product__info">
    <h6 class="cart-notification-product__name">
      <span>${rewardText}</span>
    </h6>
    <div class="cart-item__reward-title">
      <span class="reward-badge">Bezmaksas Piegāde</span>
    </div>
    <div class="cart__item_price">
      <span class="price">€0,00</span>
      <ul class="discounts list-unstyled" role="list" aria-label="Atlaide">
        <li class="discounts__discount">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-" viewBox="0 0 12 12">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path>
          </svg>
          100% Izpārdošana
        </li>
      </ul>
    </div>
    
    <div class="cart__item--footer d-flex align-items-center cart-item--reward">
    </div>

    <p class="drawer_cart-item__error no-js-inline" id="Line-item-error-free-shipping">
      <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"/>
      </svg>
      <span class="cart-item__error-text"></span>
    </p>
  </div>
</div>`;
    
    // Insert after cart_notification_topbar
    console.log('🚚 Inserting free shipping HTML after topbar');
    const topbar = document.querySelector('.cart_notification_topbar');
    if (topbar) {
      topbar.insertAdjacentHTML('afterend', freeShippingHTML);
      console.log('🚚 Free shipping item added successfully');
    } else {
      console.error('🚚 cart_notification_topbar not found');
    }
    } catch (error) {
      console.error('Error in #addFreeShippingItemToCart:', error);
    }
  }
  
  #updateFreeShippingCartItem(achievedRewards) {
    try {
      console.log('🚚 #updateFreeShippingCartItem called with rewards:', achievedRewards);
      
      // Check if feature is enabled
      const progressContainer = document.querySelector('.cart-free-shipping-progress');
      if (!progressContainer) {
        console.log('🚚 Progress container not found');
        return;
      }
      
      const showAsCartItem = progressContainer.dataset.showAsCartItem === 'true';
      if (!showAsCartItem) {
        console.log('🚚 Feature disabled');
        return;
      }
      
      // Check if free shipping is in achieved rewards
      const hasFreeShipping = achievedRewards.some(r => r.type === 'free_shipping');
      console.log('🚚 hasFreeShipping:', hasFreeShipping, 'achievedRewards types:', achievedRewards.map(r => r.type));
      
      // Check if free shipping item already exists
      const existingFreeShippingItem = document.querySelector('[data-reward-type="free_shipping"]');
      console.log('🚚 existingFreeShippingItem:', existingFreeShippingItem ? 'exists' : 'not found');
      
      if (hasFreeShipping && !existingFreeShippingItem) {
        // Add free shipping item
        console.log('🚚 Adding free shipping cart item');
        this.#addFreeShippingItemToCart().catch(err => {
          console.error('Error adding free shipping item:', err);
        });
      } else if (!hasFreeShipping && existingFreeShippingItem) {
        // Remove free shipping item
        console.log('🚚 Removing free shipping cart item (not achieved)');
        existingFreeShippingItem.remove();
      } else if (hasFreeShipping && existingFreeShippingItem) {
        console.log('🚚 Free shipping already shown, no change needed');
      } else {
        console.log('🚚 No free shipping achieved and no existing item, no change needed');
      }
    } catch (error) {
      console.error('Error in #updateFreeShippingCartItem:', error);
    }
  }

  onChange(event) {
    if (!event.target.closest("select")) {
      // Check if this is a reward item - prevent quantity changes
      const quantityInput = event.target;
      if (quantityInput) {
        const cartItem = quantityInput.closest('.cart-notification-product');
        if (cartItem && cartItem.classList.contains('cart-item--reward')) {
          // Reward items should always be quantity 1
          quantityInput.value = 1;
          return;
        }
      }
      
      // updateQuantity is now async and will check if it's a reward item
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name")
      ).then(() => {
        // Only show loading if updateQuantity didn't return early (not a reward item)
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.add("active");
      }).catch(() => {
        // If updateQuantity returns early (reward item), don't show loading
      });
    }
  }

  open() {
    console.log('Cart notification open() called');
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
    
    // Initialize You'll Love These when drawer opens
    setTimeout(() => {
      console.log('🔧 Calling #initYoullLoveThese from open()');
      this.#initYoullLoveThese();
    }, 200);
  }

  close() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);

  }

  renderContents(parsedState) {
    console.log('🎨 renderContents called with parsedState:', parsedState);
    // Ensure parsedState has sections object
    if (!parsedState) {
      console.error('renderContents: parsedState is undefined');
      return;
    }
    
    if (!parsedState.sections) {
      parsedState.sections = {};
    }
    
    // Update cart items from cart?view=soner
    // This ensures we always have the latest cart items HTML
    this.updateCartNotificationProduct().catch(err => {
      console.error('Error updating cart notification product:', err);
    });
    
    this.getSectionsToRender().forEach((section) => {
      let renderSelector = document.getElementById(section.id);
      if (renderSelector && parsedState.sections && parsedState.sections[section.id]) {
        try {
          const sectionHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id]
          );
          if (sectionHTML) {
            renderSelector.innerHTML = sectionHTML;
          }
        } catch (error) {
          console.error(`Error parsing section ${section.id}:`, error);
          // Fallback: try to use the HTML directly if parsing fails
          const parser = new DOMParser();
          const doc = parser.parseFromString(parsedState.sections[section.id], 'text/html');
          const sectionElement = doc.getElementById(section.id);
          if (sectionElement) {
            renderSelector.innerHTML = sectionElement.innerHTML;
          }
        }
      }
    });

    let cartItemCount = 0;
    if (parsedState.sections && parsedState.sections["cart-notification-count"]) {
      cartItemCount = parseInt(
        this.getSectionInnerHTML(parsedState.sections["cart-notification-count"])
      ) || 0;
    }

    // Calculate real item count (excluding reward items)
    let realItemCount = cartItemCount || parsedState.item_count || 0;
    if (parsedState.items && parsedState.items.length > 0) {
      // Count only non-reward items
      realItemCount = parsedState.items.filter(item => {
        return !(item.properties && (
          item.properties._reward === 'true' || 
          item.properties._gift === 'true'
        ));
      }).length;
    }

    // Update cart notification count in header
    this.#updateCartNotificationCount(cartItemCount || parsedState.item_count || 0);
    
    // Update cart total (exclude reward/gift items)
    this.#updateCartTotal(parsedState);

    //console.log(cartItemCount);

    // Use realItemCount to determine if cart is empty (excluding reward items)
    if (realItemCount == 0) {
      this.emptyCartItem.classList.add("no-js-inline");
      this.emptyCartButtonDisable.classList.add("no-js-inline");
      this.cartItemMessageShow.classList.remove("no-js-inline");
      this.cartAddSuccess.classList.add("no-js-inline");
      this.cartEmptyHead.classList.add("no-js-inline");
       this.emptyCartHeader.classList.add('empty__cart');
      
      // Hide cart header when cart is empty (or only reward items)
      this.#hideCartHeader();
    } else {
      this.emptyCartItem.classList.remove("no-js-inline");
      this.emptyCartButtonDisable.classList.remove("no-js-inline");
      this.cartItemMessageShow.classList.add("no-js-inline");
      this.cartAddSuccess.classList.remove("no-js-inline");
      this.cartEmptyHead.classList.remove("no-js-inline");
      this.emptyCartHeader.classList.remove('empty__cart');
      
      // Show cart header when cart has items
      this.#showCartHeader();
    }

    // Update cart header count (use realItemCount for display)
    this.#updateCartHeaderCount(realItemCount);

    // Check if first item was added (cart was empty, now has items)
    // Use realItemCount to exclude reward items
    const wasEmpty = this.currentItemCount === 0;
    const isNowFilled = realItemCount > 0;
    
    if (wasEmpty && isNowFilled) {
      // First item added - create and start timer
      localStorage.removeItem('cart_expiration_start_time');
      localStorage.setItem('cart_expiration_start_time', Date.now().toString());
      // Create timer banner if it doesn't exist
      this.#createTimerBanner();
      // Show progress bar
      this.#showProgressBar();
    } else if (realItemCount === 0) {
      // Cart emptied (or only reward items remain) - clear timer and hide banner
      this.#clearCartExpiration();
      // Hide progress bar
      this.#hideProgressBar();
    } else if (isNowFilled) {
      // Cart has items - make sure timer exists and is visible
      this.#ensureTimerBanner();
      // Show progress bar
      this.#showProgressBar();
    }

    // Re-bind cart header close button after render
    const cartHeaderClose = document.querySelector('.cart-header__close');
    if (cartHeaderClose) {
      cartHeaderClose.addEventListener("click", this.close.bind(this));
    }

    // Initialize new features after render
    this.#initCartFeatures(parsedState);
    
    // If cart is empty (or only reward items), hide progress bar
    if (realItemCount === 0) {
      this.#hideProgressBar();
      return;
    }
    
    // Update progress bar and messages every time cart is rendered
    // Wait 2 seconds after render, then fetch fresh cart state and update progress bar
    // This ensures we have the latest cart data, especially after first item is added
    setTimeout(async () => {
      try {
        // Fetch fresh cart state to ensure we have the latest data
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Create parsedState-like object with fresh cart data
        const freshParsedState = {
          item_count: cart.item_count || 0,
          total_price: cart.total_price || 0,
          items: cart.items || []
        };
        
        // Only update if cart still has items
        if (freshParsedState.item_count > 0) {
          this.updateProgressBar(freshParsedState);
        } else {
          // Cart was emptied, hide progress bar
          this.#hideProgressBar();
        }
      } catch (error) {
        console.error('Error fetching fresh cart state:', error);
        // Fallback to using the original parsedState
        this.updateProgressBar(parsedState);
      }
    }, 100);

    if (this.header) this.header.reveal();
    this.open();
  }

  #hideCartHeader() {
    const cartHeader = document.querySelector('.cart-header');
    if (cartHeader) {
     // cartHeader.style.display = 'none';
    }
  }
  
  #showCartHeader() {
    const cartHeader = document.querySelector('.cart-header');
    if (cartHeader) {
      cartHeader.style.display = '';
    }
  }
  
  #updateCartHeaderCount(count) {
    const cartHeaderCount = document.querySelector('.cart-header__count');
    if (!cartHeaderCount) return;

    const countTextTemplate = cartHeaderCount.dataset.countText;
    if (!countTextTemplate) return;

    const updatedText = countTextTemplate.replace(/\{\{count\}\}/g, count);
    cartHeaderCount.textContent = updatedText;
    
    // Show/hide based on count
    if (count === 0) {
      cartHeaderCount.style.display = 'none';
    } else {
      cartHeaderCount.style.display = 'block';
    }
  }

  #updateCartNotificationCount(itemCount) {
    const cartNotificationCount = document.getElementById('cart-notification-count');
    if (!cartNotificationCount) return;
    
    // Update the count text
    cartNotificationCount.textContent = itemCount;
    
    // Show/hide based on count (if count is >= 100, it's hidden by Liquid)
    if (itemCount === 0) {
      //cartNotificationCount.style.display = 'none';
    } else if (itemCount < 100) {
      cartNotificationCount.style.display = '';
    }
    
    // Also update the visually-hidden span if it exists
    const visuallyHidden = cartNotificationCount.nextElementSibling;
    if (visuallyHidden && visuallyHidden.classList.contains('visually-hidden')) {
      // Try to update the translation if available
      const translationKey = 'sections.header.cart_count';
      if (window.cartStrings && window.cartStrings.itemCount) {
        visuallyHidden.textContent = window.cartStrings.itemCount.replace('[count]', itemCount);
      } else {
        // Fallback: simple count text
        visuallyHidden.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
      }
    }
  }

  async #updateCartTotal(cartData = null) {
    const cartNotificationTotal = document.getElementById('cart-notification-total');
    const cartNotificationSubtotal = document.getElementById('cart-notification-subtotal');
    
    if (!cartNotificationTotal && !cartNotificationSubtotal) return;
    
    // If cartData not provided, fetch it
    if (!cartData) {
      try {
        const response = await fetch('/cart.js');
        cartData = await response.json();
      } catch (error) {
        console.error('Error fetching cart for total update:', error);
        return;
      }
    }
    
    // Calculate total WITHOUT reward/gift items
    let totalWithoutRewards = 0;
    
    if (cartData && cartData.items) {
      totalWithoutRewards = cartData.items
        .filter(item => {
          // Exclude reward/gift items
          if (!item.properties) return true;
          const hasReward = item.properties._reward === 'true';
          const hasGift = item.properties._gift === 'true';
          return !(hasReward || hasGift);
        })
        .reduce((sum, item) => sum + (item.final_line_price || 0), 0);
    } else if (typeof cartData === 'number') {
      // Fallback: if only a number is passed (old behavior)
      totalWithoutRewards = cartData;
    }
    
    // Format price
    const formattedPrice = this.#formatMoney(totalWithoutRewards);
    
    // Update checkout button total
    if (cartNotificationTotal) {
      cartNotificationTotal.textContent = formattedPrice;
    }
    
    // Update subtotal in cart footer
    if (cartNotificationSubtotal) {
      cartNotificationSubtotal.textContent = formattedPrice;
    }
  }

  async #updateCartSavings() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      let totalSavings = 0;
      
      // Calculate savings ONLY from reward products (not Shopify discounts)
      // Reward products are shown as 100% off, so their original_line_price = savings
      for (const item of cart.items) {
        const isRewardItem = item.properties && (
          item.properties._reward === 'true' || 
          item.properties._gift === 'true'
        );
        
        if (isRewardItem) {
          totalSavings += item.original_line_price;
        }
      }
      
      console.log('💰 Total savings from reward products:', totalSavings, 'cents');
      
      const savingsElement = document.getElementById('cart-notification-savings');
      const savingsAmountElement = document.getElementById('cart-notification-savings-amount');
      
      if (totalSavings > 0) {
        // Show savings
        if (savingsElement) {
          savingsElement.style.display = 'flex';
          if (savingsAmountElement) {
            const formattedSavings = this.#formatMoney(totalSavings);
            console.log('💰 Formatted savings:', formattedSavings);
            savingsAmountElement.textContent = `-${formattedSavings}`;
          }
        }
      } else {
        // Hide savings
        if (savingsElement) {
          savingsElement.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error updating cart savings:', error);
    }
  }

  #initCartFeatures(parsedState) {
    console.log('🔧 Initializing cart features');
    // Initialize cart expiration timer (only if cart has items)
    // Timer initialization is handled in renderContents based on cart state
    // Don't initialize here to avoid duplicate timers
    
    // Progress bar is updated in renderContents via #updateProgressBar
    // No need to initialize here separately
    
    // Initialize shipping protection
    this.#initShippingProtection();
    
    // Initialize subscription upgrade
    this.#initSubscriptionUpgrade();
    
    // Initialize you'll love these (with delay to ensure DOM is ready)
    console.log('🔧 Scheduling You\'ll Love These initialization');
    setTimeout(() => {
      console.log('🔧 Calling #initYoullLoveThese now');
      this.#initYoullLoveThese();
    }, 100);
  }

  #initCartExpiration() {
    // Clear any existing interval first
    if (this.expirationInterval) {
      clearInterval(this.expirationInterval);
      this.expirationInterval = null;
    }

    // Use setTimeout to ensure DOM is ready after render
    setTimeout(() => {
      const expirationBanner = document.querySelector('.cart-expiration-banner');
      if (!expirationBanner) {
        // If banner doesn't exist, it means cart is empty (Liquid didn't render it)
        // So we don't need to do anything
        return;
      }
      
      // Show banner if it was hidden
      expirationBanner.style.display = '';

      const minutes = parseInt(expirationBanner.dataset.expirationMinutes) || 10;
      const timerElement = expirationBanner.querySelector('.cart-expiration-banner__timer');
      if (!timerElement) {
        console.warn('Cart expiration timer element not found');
        return;
      }

      // Get or set cart start time
      const cartStartTimeKey = 'cart_expiration_start_time';
      const expirationDuration = minutes * 60 * 1000; // Convert to milliseconds
      
      let cartStartTime = localStorage.getItem(cartStartTimeKey);
      const now = Date.now();
      
      // If no start time exists or cart was cleared, set new start time
      if (!cartStartTime) {
        cartStartTime = now.toString();
        localStorage.setItem(cartStartTimeKey, cartStartTime);
      }
      
      const startTime = parseInt(cartStartTime);
      const elapsed = now - startTime;
      const remaining = expirationDuration - elapsed;
      
      // If timer expired, reset it
      if (remaining <= 0) {
        localStorage.setItem(cartStartTimeKey, now.toString());
        this.#startTimer(timerElement, minutes * 60);
        return;
      }
      
      // Calculate remaining seconds
      let totalSeconds = Math.floor(remaining / 1000);
      
      const updateTimer = () => {
        const now = Date.now();
        const elapsed = now - startTime;
        const remaining = expirationDuration - elapsed;
        totalSeconds = Math.floor(remaining / 1000);
        
        if (totalSeconds <= 0) {
          if (this.expirationInterval) {
            clearInterval(this.expirationInterval);
            this.expirationInterval = null;
          }
          timerElement.textContent = '00:00';
          localStorage.removeItem(cartStartTimeKey);
          return;
        }
        
        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;
        timerElement.textContent = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      };

      // Initial update
      updateTimer();
      
      // Set interval
      this.expirationInterval = setInterval(updateTimer, 1000);
    }, 100);
  }

  #startTimer(timerElement, totalSeconds) {
    const updateTimer = () => {
      if (totalSeconds <= 0) {
        if (this.expirationInterval) {
          clearInterval(this.expirationInterval);
          this.expirationInterval = null;
        }
        timerElement.textContent = '00:00';
        localStorage.removeItem('cart_expiration_start_time');
        return;
      }
      
      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;
      timerElement.textContent = `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      
      totalSeconds--;
    };

    updateTimer();
    this.expirationInterval = setInterval(updateTimer, 1000);
  }

  #hideCartExpiration() {
    const expirationBanner = document.querySelector('.cart-expiration-banner');
    if (expirationBanner) {
      expirationBanner.style.display = 'none';
    }
    
    // Clear interval if exists
    if (this.expirationInterval) {
      clearInterval(this.expirationInterval);
      this.expirationInterval = null;
    }
  }

  #clearCartExpiration() {
    // Clear all timer-related localStorage variables
    localStorage.removeItem('cart_expiration_start_time');
    
    // Clear interval if exists
    if (this.expirationInterval) {
      clearInterval(this.expirationInterval);
      this.expirationInterval = null;
    }
    
    // Hide banner
    this.#hideCartExpiration();
  }

  #createTimerBanner() {
    // Check if banner already exists
    let expirationBanner = document.querySelector('.cart-expiration-banner');
    
    if (!expirationBanner) {
      // Banner should always exist in template if cart_expiration_enable is true
      // If it doesn't exist, it means the setting is disabled
      return;
    }
    
    // Check if there are multiple banners (duplicate issue)
    const allBanners = document.querySelectorAll('.cart-expiration-banner');
    if (allBanners.length > 1) {
      // Remove duplicates, keep only the first one
      for (let i = 1; i < allBanners.length; i++) {
        allBanners[i].remove();
      }
      expirationBanner = document.querySelector('.cart-expiration-banner');
    }
    
    // Show banner
    expirationBanner.style.display = '';
    
    // Only initialize timer if it's not already running
    if (!this.expirationInterval) {
      // Initialize timer after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.#initCartExpiration();
      }, 150);
    }
  }

  #ensureTimerBanner() {
    const expirationBanner = document.querySelector('.cart-expiration-banner');
    if (!expirationBanner) {
      // Banner doesn't exist, create it
      this.#createTimerBanner();
    } else {
      // Check for duplicates
      const allBanners = document.querySelectorAll('.cart-expiration-banner');
      if (allBanners.length > 1) {
        // Remove duplicates, keep only the first one
        for (let i = 1; i < allBanners.length; i++) {
          allBanners[i].remove();
        }
      }
      
      // Banner exists, make sure it's visible
      expirationBanner.style.display = '';
      
      // Only re-initialize timer if not running
      if (!this.expirationInterval) {
        setTimeout(() => {
          this.#initCartExpiration();
        }, 100);
      }
    }
  }

  #showProgressBar() {
    const progressContainer = document.querySelector('.cart-free-shipping-progress');
    if (progressContainer) {
      progressContainer.style.display = '';
    }
  }

  #hideProgressBar() {
    const progressContainer = document.querySelector('.cart-free-shipping-progress');
    if (progressContainer) {
      progressContainer.style.display = 'none';
    }
  }

  #initFreeShippingProgress(parsedState) {
    const progressContainer = document.querySelector('.cart-free-shipping-progress');
    if (!progressContainer) return;

    const rewardMode = progressContainer.dataset.rewardMode || 'all';
    const rewards = this.#parseRewardsFromDOM(progressContainer);
    if (rewards.length === 0) return;

    const currentTotal = parsedState.total_price || 0;
    // Max threshold should be the highest enabled reward threshold
    const maxThreshold = rewards.length > 0 
      ? Math.max(...rewards.map(r => r.threshold))
      : parseInt(progressContainer.dataset.maxThreshold) || 20000;
    
    const progressFill = progressContainer.querySelector('.free-shipping-progress__fill');
    const progressWalker = progressContainer.querySelector('.free-shipping-progress__walker');
    const messageElement = progressContainer.querySelector('.free-shipping-progress__message');
    
    if (!progressFill || !progressWalker || !messageElement) return;

    // Calculate progress percentage
    const progressPercent = maxThreshold > 0 
      ? Math.min((currentTotal / maxThreshold) * 100, 100)
      : 0;
    
    // Update progress fill
    progressFill.style.width = `${progressPercent}%`;
    
    // Position walker at the end of the filled section
    const walkerPosition = Math.min(progressPercent, 100);
    // Walker should be centered on the fill end, so we use the fill width directly
    progressWalker.style.left = `calc(${walkerPosition}% - 12px)`;
    
    // Ensure progress bar is visible
    progressFill.style.display = 'block';

    // Find next reward
    const nextReward = rewards.find(r => r.threshold > currentTotal);
    const achievedRewards = rewards.filter(r => r.threshold <= currentTotal);

    // Update reward visual states (add/remove achieved class)
    const rewardElements = progressContainer.querySelectorAll('.free-shipping-reward');
    const achievedTextMode = progressContainer.dataset.achievedTextMode || 'last';
    
    for (const rewardElement of rewardElements) {
      const rewardThreshold = parseInt(rewardElement.dataset.threshold) || 0;
      const rewardText = rewardElement.querySelector('.free-shipping-reward__text');
      const isAchieved = rewardThreshold <= currentTotal && rewardThreshold > 0;
      
      if (isAchieved) {
        rewardElement.classList.add('achieved');
        
        // Show/hide text based on mode
        if (achievedTextMode === 'all') {
          // Show text for all achieved rewards
          if (rewardText) rewardText.style.display = '';
        } else if (achievedTextMode === 'last') {
          // Show text only for the last (highest) achieved reward
          const isLastAchieved = achievedRewards.length > 0 && 
            rewardThreshold === Math.max(...achievedRewards.map(r => r.threshold));
          if (rewardText) {
            rewardText.style.display = isLastAchieved ? '' : 'none';
          }
        } else {
          // Hide text for all achieved rewards
          if (rewardText) rewardText.style.display = 'none';
        }
      } else {
        rewardElement.classList.remove('achieved');
        // Show text for non-achieved rewards
        if (rewardText) rewardText.style.display = '';
      }
    }

    // Update message
    if (achievedTextMode === 'all' && achievedRewards.length > 0) {
      // Show all achieved rewards text
      const achievedTexts = achievedRewards.map(reward => {
        const rewardElement = Array.from(rewardElements).find(el => 
          parseInt(el.dataset.threshold) === reward.threshold
        );
        if (rewardElement) {
          const rewardTextEl = rewardElement.querySelector('.free-shipping-reward__text');
          return rewardTextEl ? rewardTextEl.textContent : '';
        }
        return '';
      }).filter(text => text !== '');
      
      let messageHTML = '';
      if (achievedTexts.length > 0) {
        messageHTML = achievedTexts.map(text => `<p class="reward_earned_text">✓ ${text}</p>`).join('');
      }
      
      if (nextReward) {
        const remaining = nextReward.threshold - currentTotal;
        const remainingFormatted = this.#formatMoney(remaining);
        messageHTML += `<p>${this.#getProgressMessage(remainingFormatted, nextReward)}</p>`;
      } else if (achievedTexts.length === 0) {
        messageHTML = `<p class="message-success">🎉 ${this.#getSuccessMessage()}</p>`;
      }
      
      messageElement.innerHTML = messageHTML;
    } else if (nextReward) {
      const remaining = nextReward.threshold - currentTotal;
      const remainingFormatted = this.#formatMoney(remaining);
      messageElement.innerHTML = `<p>${this.#getProgressMessage(remainingFormatted, nextReward)}</p>`;
    } else {
      messageElement.innerHTML = `<p class="message-success">🎉 ${this.#getSuccessMessage()}</p>`;
    }

    // Handle reward application
    if (achievedRewards.length > 0) {
      this.#applyRewards(achievedRewards, rewardMode, currentTotal);
    }

    // Animate walker to next reward
    if (nextReward) {
      this.#animateWalkerToReward(progressWalker, nextReward, maxThreshold, currentTotal);
    }
  }

  #parseRewardsFromDOM(progressContainer) {
    const rewards = [];
    // Only parse rewards from the above container (not the hidden one below)
    const rewardsContainer = progressContainer.querySelector('.free-shipping-progress__rewards--above');
    if (!rewardsContainer) return rewards;
    
    const rewardElements = rewardsContainer.querySelectorAll('.free-shipping-reward');
    
    for (const rewardElement of rewardElements) {
      const threshold = parseInt(rewardElement.dataset.threshold) || 0;
      const type = rewardElement.dataset.type || 'free_shipping';
      const value = rewardElement.dataset.value || '';
      const index = parseInt(rewardElement.dataset.rewardIndex) || 0;
      
      if (threshold > 0) {
        rewards.push({
          threshold: threshold,
          type: type,
          value: value,
          index: index,
          element: rewardElement
        });
      }
    }
    
    return rewards.sort((a, b) => a.threshold - b.threshold);
  }

  #formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `€${amount.replace('.', ',')}`;
  }

  #getProgressMessage(remaining, reward) {
    if (reward.type === 'free_shipping') {
      return `<strong>${remaining}</strong> līdz bezmaksas piegādei!`;
    } else if (reward.type === 'order_discount') {
      return `<strong>${remaining}</strong>  ${reward.value}% līdz atlaidei!`;
    } else if (reward.type === 'gift_product') {
      return `<strong>${remaining}</strong> līdz bezmaksas dāvanai!`;
    }
    return `<strong>${remaining}</strong> līdz nākamajai dāvanai!`;
  }


  #getSuccessMessage() {
    return '';//return 'Jūs kvalificējaties bezmaksas piegādei!';
  }

  #animateWalkerToReward(walker, reward, maxThreshold, currentTotal) {
    const targetPercent = (reward.threshold / maxThreshold) * 100;
    const currentPercent = Math.min((currentTotal / maxThreshold) * 100, 100);
    
    if (targetPercent <= currentPercent) return;

    const duration = 1000;
    const startPercent = currentPercent;
    const distance = targetPercent - startPercent;
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const currentPosition = startPercent + (distance * easeProgress);
      
      walker.style.left = `calc(${currentPosition}% - 12px)`;
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }

  async #applyRewards(achievedRewards, rewardMode, currentTotal) {
    const rewardsToApply = rewardMode === 'last' 
      ? [achievedRewards[achievedRewards.length - 1]]
      : achievedRewards;

    for (let i = 0; i < rewardsToApply.length; i++) {
      const reward = rewardsToApply[i];
      
      if (reward.type === 'order_discount' && reward.value) {
        // Apply discount code if available
        const discountCode = `REWARD${reward.value}`;
        await this.#applyDiscountCode(discountCode);
      } else if (reward.type === 'free_shipping') {
        // Free shipping is usually handled by discount or automatic
        await this.#applyDiscountCode('FREESHIP');
      } else if (reward.type === 'gift_product' && reward.value) {
        // Get reward title from DOM element
        let rewardTitle = '';
        if (reward.element) {
          const rewardTextEl = reward.element.querySelector('.free-shipping-reward__text');
          if (rewardTextEl) {
            rewardTitle = rewardTextEl.textContent.trim();
          }
        }
        // Add gift product to cart with title and threshold
        await this.#addGiftProductToCart(reward.value, rewardTitle, reward.threshold);
      }
    }
  }

  async #addGiftProductToCart(productHandleOrVariantId, rewardTitle = '', rewardThreshold = 0) {
    try {
      // First check if this reward product is already in cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Check if it's a variant ID (numeric) or product handle
      const isVariantId = /^\d+$/.test(productHandleOrVariantId);
      let variantId = null;
      
      if (isVariantId) {
        variantId = productHandleOrVariantId;
      } else {
        // Product handle - need to get first available variant
        const productResponse = await fetch(`/products/${productHandleOrVariantId}.json`);
        const productData = await productResponse.json();
        
        if (productData.product && productData.product.variants && productData.product.variants.length > 0) {
          variantId = productData.product.variants[0].id;
        }
      }
      
      if (!variantId) {
        console.error('Could not determine variant ID for gift product:', productHandleOrVariantId);
        return;
      }
      
      // Check if this variant is already in cart with reward property
      const existingItem = cart.items.find(item => {
        const isSameVariant = item.variant_id.toString() === variantId.toString();
        const hasRewardProperty = item.properties && (
          item.properties._reward === 'true' || 
          item.properties._gift === 'true'
        );
        return isSameVariant && hasRewardProperty;
      });
      
      if (existingItem) {
        // Reward already in cart, ensure quantity is 1
        if (existingItem.quantity !== 1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingItem.key,
              quantity: 1
            })
          });
        }
        return; // Already in cart, no action needed
      }
      
      // Add reward product to cart with properties
      const properties = {
        '_reward': 'true',
        '_gift': 'true'
      };
      
      // Add reward title as property if provided
      if (rewardTitle) {
        properties['_reward_title'] = rewardTitle;
      }
      
      // Add reward threshold as property for accurate removal checks
      if (rewardThreshold > 0) {
        properties['_reward_threshold'] = rewardThreshold.toString();
      }
      
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: properties
        })
      });
      
      // Check response status and content type
      const contentType = addResponse.headers.get('content-type') || '';
      
      // If response is JSON, parse it
      if (contentType.includes('application/json')) {
        const addData = await addResponse.json();
        
        // Check if response indicates success
        if (addData.error || addData.status === 'error') {
          console.error('Error adding gift product:', addData.error || addData.description);
          return false;
        }
        
        // Update cart notification product after successful addition
        await this.updateCartNotificationProduct();
        
        // Update cart count in header
        const updatedCartResponse = await fetch('/cart.js');
        const updatedCart = await updatedCartResponse.json();
        this.#updateCartNotificationCount(updatedCart.item_count || 0);
        await this.#updateCartTotal(updatedCart);
        
        return true;
      } else {
        // If response is not JSON, it might be HTML (redirect)
        const responseText = await addResponse.text();
        
        // If response is HTML (redirect), log but don't follow it
        if (responseText.includes('<!DOCTYPE') || responseText.includes('<html')) {
          console.error('Cart add request resulted in HTML redirect');
          return false;
        }
        
        // Try to parse as JSON anyway (sometimes content-type is wrong)
        try {
          const addData = JSON.parse(responseText);
          if (addData.error || addData.status === 'error') {
            console.error('Error adding gift product:', addData.error || addData.description);
            return false;
          }
          
          // Update cart notification product after successful addition
          await this.updateCartNotificationProduct();
          
          // Update cart count in header
          const updatedCartResponse = await fetch('/cart.js');
          const updatedCart = await updatedCartResponse.json();
          this.#updateCartNotificationCount(updatedCart.item_count || 0);
          await this.#updateCartTotal(updatedCart);
          
          return true;
        } catch (e) {
          console.error('Could not parse response as JSON:', e);
          return false;
        }
      }
      
      // If we reach here, product was added successfully
      return true;
    } catch (error) {
      console.error('Error adding gift product to cart:', error);
      return false;
    }
  }

  async #applyDiscountCode(code) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Check if discount already applied
      const hasDiscount = cart.discount_applications?.some(
        app => app.title === code || app.code === code
      );
      
      if (hasDiscount) return;

      // Apply discount via cart update
      const formData = new FormData();
      formData.append('discount', code);
      
      await fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      });
    } catch (error) {
      console.error('Error applying reward:', error);
    }
  }

  #initShippingProtection() {
    const protectionCheckbox = document.querySelector('.cart-shipping-protection__checkbox');
    if (!protectionCheckbox) return;

    protectionCheckbox.addEventListener('change', async (e) => {
      const isChecked = e.target.checked;
      const variantId = e.target.dataset.protectionVariantId;
      
      if (!variantId) {
        console.error('Shipping protection variant ID not set');
        return;
      }

      const checkbox = e.target;
      try {
        if (isChecked) {
          // Add shipping protection to cart
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        } else {
          // Remove shipping protection from cart
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const protectionItem = cart.items.find(item => item.variant_id.toString() === variantId);
          
          if (protectionItem) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: protectionItem.key,
                quantity: 0
              })
            });
          }
        }
        
        // Reload cart
        location.reload();
      } catch (error) {
        console.error('Error updating shipping protection:', error);
        checkbox.checked = !isChecked;
      }
    });
  }

  #initSubscriptionUpgrade() {
    const upgradeButton = document.querySelector('.cart-subscription-upgrade__button');
    if (!upgradeButton) return;

    upgradeButton.addEventListener('click', async () => {
      const subscriptionHandle = upgradeButton.dataset.subscriptionHandle;
      if (!subscriptionHandle) {
        console.error('Subscription handle not set');
        return;
      }

      try {
        // Get current cart items
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Convert all items to subscription
        const updates = cart.items.map(item => ({
          id: item.key,
          properties: {
            ...item.properties,
            _selling_plan: subscriptionHandle
          }
        }));

        // Update cart with subscription
        for (const update of updates) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [update.id]: update } })
          });
        }
        
        location.reload();
      } catch (error) {
        console.error('Error upgrading to subscription:', error);
      }
    });
  }

  async #initYoullLoveThese() {
    // Only initialize once to prevent duplicate fetches
    if (this.youllLoveTheseInitialized) {
      console.log('💝 You\'ll Love These already initialized, skipping');
      return;
    }
    
    const container = document.querySelector('.cart-youll-love-these__products');
    if (!container) {
      console.log('💝 You\'ll Love These container not found');
      return;
    }
    
    this.youllLoveTheseInitialized = true;
    console.log('💝 Initializing You\'ll Love These');

    const collectionHandle = container.dataset.collectionHandle;
    const mode = container.dataset.mode || 'collection';
    const showOutOfStock = container.dataset.showOutOfStock === 'true';
    const productCount = parseInt(container.dataset.productCount) || 4;
    const loadingElement = container.querySelector('.cart-youll-love-these__loading');
    
    console.log('💝 You\'ll Love These - showOutOfStock:', showOutOfStock, 'productCount:', productCount);

    try {
      let products = [];

      if (mode === 'collection' && collectionHandle) {
        // Fetch more products than needed to account for out of stock filtering
        const fetchLimit = showOutOfStock ? productCount : productCount * 2;
        const response = await fetch(`/collections/${collectionHandle}/products.json?limit=${fetchLimit}`);
        const data = await response.json();
        products = data.products || [];
      } else {
        // Fetch similar products based on cart items
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        if (cart.items.length > 0) {
          // Get product IDs from cart
          const productIds = cart.items.map(item => item.product_id);
          
          // Fetch recommendations (simplified - you might want to use a recommendation API)
          for (const productId of productIds.slice(0, 2)) {
            const productResponse = await fetch(`/products/${productId}.json`);
            const productData = await productResponse.json();
            
            // Get related products from same collection
            if (productData.product.collections && productData.product.collections.length > 0) {
              const collectionHandle = productData.product.collections[0].handle;
              const collectionResponse = await fetch(`/collections/${collectionHandle}/products.json?limit=2`);
              const collectionData = await collectionResponse.json();
              products.push(...(collectionData.products || []));
            }
          }
        }
      }

      // Filter out of stock products if setting is disabled
      if (!showOutOfStock) {
        products = products.filter(product => {
          // Check if at least one variant is available
          const hasAvailableVariant = product.variants.some(v => v.available);
          console.log(`💝 Product "${product.title}" - hasAvailableVariant:`, hasAvailableVariant);
          return hasAvailableVariant;
        });
      }

      // Remove duplicates and limit to specified product count
      products = products.filter((p, i, self) => 
        i === self.findIndex(pr => pr.id === p.id)
      ).slice(0, productCount);
      
      console.log(`💝 Final product count: ${products.length} (requested: ${productCount})`);

      if (loadingElement) loadingElement.remove();

      if (products.length === 0) {
        container.innerHTML = '<p class="cart-youll-love-these__empty">Nav pieejamu produktu</p>';
        return;
      }

      // Render products
      container.innerHTML = products.map(product => this.#renderProductCard(product)).join('');
      
      // Initialize add to cart buttons
      container.querySelectorAll('.cart-youll-love-these__add').forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const variantId = button.dataset.variantId;
          this.#addProductToCart(variantId);
        });
      });
    } catch (error) {
      console.error('Error loading you\'ll love these:', error);
      if (loadingElement) loadingElement.remove();
      container.innerHTML = '<p class="cart-youll-love-these__error">Kļūda ielādējot produktus</p>';
    }
  }

  #renderProductCard(product) {
    const variant = product.variants?.[0];
    if (!variant) return '';

    const image = product.images?.[0]?.src || '';
    
    // Shopify returns price as string in EUR format, convert to cents
    // e.g., "2.39" -> 239 cents
    const priceInCents = typeof variant.price === 'string' 
      ? Math.round(parseFloat(variant.price) * 100)
      : variant.price;

    return `
      <div class="cart-youll-love-these__product">
        <a href="/products/${product.handle}" class="cart-youll-love-these__product-image">
          <img src="${image}" 
               alt="${product.title}" 
               loading="lazy"
               style="width: var(--youll-love-image-width, 100px); height: auto; object-fit: cover;">
        </a>
        <div class="cart-youll-love-these__product-info">
          <h4 class="cart-youll-love-these__product-title">
            <a href="/products/${product.handle}">${product.title}</a>
          </h4>
          <div class="cart-youll-love-these__product-price">${this.#formatMoney(priceInCents)}</div>
          ${product.variants.length > 1 ? `
            <select class="cart-youll-love-these__product-variant" data-product-id="${product.id}">
              ${product.variants.map(v => `
                <option value="${v.id}" ${v.available ? '' : 'disabled'}>${v.title}</option>
              `).join('')}
            </select>
          ` : ''}
          <button class="button cart-youll-love-these__add" 
                  data-variant-id="${variant.id}"
                  ${!variant.available ? 'disabled' : ''}>
            ${variant.available ? 'Pievienot' : 'Nav pieejams'}
          </button>
        </div>
      </div>
    `;
  }

  async #addProductToCart(variantId) {
    console.log('💝 Adding product to cart:', variantId);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (response.ok) {
        console.log('💝 Product added successfully, refreshing cart drawer');
        // Fetch updated cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // Update cart drawer content
        await this.updateCartNotificationProduct();
        
        // Update cart counts
        this.#updateCartNotificationCount(cart.item_count || 0);
        this.#updateCartHeaderCount(cart.item_count || 0);
        // Update cart total (exclude reward/gift items)
        await this.#updateCartTotal(cart);
        
        // Update progress bar
        const parsedState = {
          item_count: cart.item_count,
          total_price: cart.total_price,
          items: cart.items
        };
        await this.updateProgressBar(parsedState);
        
        console.log('💝 Cart drawer refreshed successfully');
      } else {
        console.error('💝 Error adding product to cart:', response.status);
      }
    } catch (error) {
      console.error('💝 Error adding product to cart:', error);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount"
      }
    ];
  }

  async updateQuantity(line, quantity, name) {
    // First check: Verify from cart API if this is a reward item
    // This is more reliable than DOM checks and should be done first
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item by line number (1-based index)
      const itemIndex = parseInt(line) - 1;
      if (itemIndex >= 0 && itemIndex < cart.items.length) {
        const item = cart.items[itemIndex];
        const isReward = item.properties && (
          item.properties._reward === 'true' || 
          item.properties._gift === 'true'
        );
        
        if (isReward) {
          // This is a reward item, prevent quantity change
          const quantityInput = document.getElementById(`Quantity-${line}`);
          if (quantityInput) {
            quantityInput.value = 1;
          }
          console.log('Prevented quantity change for reward item');
          return;
        }
      }
    } catch (error) {
      console.error('Error checking cart for reward item:', error);
      // If check fails, continue with normal flow
    }
    
    // Second check: Check DOM for reward item class (fallback)
    const quantityInput = document.getElementById(`Quantity-${line}`);
    if (quantityInput) {
      const cartItem = quantityInput.closest('.cart-notification-product');
      if (cartItem && cartItem.classList.contains('cart-item--reward')) {
        // Reward items should always be quantity 1
        quantityInput.value = 1;
        return;
      }
    }
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        
        // Ensure reward items have quantity 1
        this.#ensureRewardItemsQuantity(parsedState);
        
        if (parsedState.item_count > 0) {
          this.updateLiveRegions(line, parsedState.item_count);
        }
        // Update cart header count
        this.#updateCartHeaderCount(parsedState.item_count || 0);
        // Update cart total (exclude reward/gift items)
        this.#updateCartTotal(parsedState);
        // Update progress bar after cart change
        this.updateProgressBar(parsedState);
      })
      .catch((error) => {
        console.error('Error updating quantity:', error);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
		 this.notification.classList.remove('loading-bar');
      });
  }

  async updateProgressBar(parsedState, skipRewardRemoval = false) {
    const progressContainer = document.querySelector('.cart-free-shipping-progress');
    if (!progressContainer) {
      // If container doesn't exist, try again after a short delay
      setTimeout(() => {
        if (parsedState) {
          this.updateProgressBar(parsedState);
        }
      }, 100);
      return;
    }

    // If cart is empty, hide progress bar
    if (!parsedState || parsedState.item_count === 0 || parsedState.total_price === 0) {
      this.#hideProgressBar();
      return;
    }

    // Ensure container is visible
    if (progressContainer.style.display === 'none') {
      progressContainer.style.display = '';
    }

    const rewardMode = progressContainer.dataset.rewardMode || 'all';
    const rewards = this.#parseRewardsFromDOM(progressContainer);
    if (rewards.length === 0) return;

    // Calculate total WITHOUT reward items for accurate threshold calculation
    let currentTotal = 0;
    if (parsedState && parsedState.items) {
      currentTotal = parsedState.items
        .filter(item => {
          if (!item.properties) return true;
          const hasReward = item.properties._reward === 'true';
          const hasGift = item.properties._gift === 'true';
          return !(hasReward || hasGift);
        })
        .reduce((sum, item) => sum + (item.final_line_price || 0), 0);
    } else {
      // Fallback to parsedState.total_price if items not available
      currentTotal = parsedState?.total_price || 0;
    }
    
    console.log('updateProgressBar - currentTotal (excluding rewards):', currentTotal, 'parsedState.total_price:', parsedState?.total_price);
    
    if (!parsedState || currentTotal === undefined) {
      console.warn('Cart state not ready for progress bar update');
      this.#hideProgressBar();
      return;
    }
    // Max threshold should be the highest enabled reward threshold
    const maxThreshold = rewards.length > 0 
      ? Math.max(...rewards.map(r => r.threshold))
      : parseInt(progressContainer.dataset.maxThreshold) || 20000;
    
    const progressFill = progressContainer.querySelector('.free-shipping-progress__fill');
    const progressWalker = progressContainer.querySelector('.free-shipping-progress__walker');
    const messageElement = progressContainer.querySelector('.free-shipping-progress__message');
    
    if (!progressFill || !progressWalker || !messageElement) return;

    // Calculate progress percentage
    const progressPercent = maxThreshold > 0 
      ? Math.min((currentTotal / maxThreshold) * 100, 100)
      : 0;
    
    // Update progress fill - ensure it's visible and has correct width
    progressFill.style.display = 'block';
    progressFill.style.width = `${progressPercent}%`;
    progressFill.style.transition = 'width 0.5s ease-out';
    
    // Walker should always be at the end of the filled section
    // Position walker at progressPercent (end of fill)
    const walkerPosition = Math.min(progressPercent, 100);
    progressWalker.style.transition = 'left 0.5s ease-out';
    progressWalker.style.left = `calc(${walkerPosition}% - 12px)`;

    // Find next reward
    const nextReward = rewards.find(r => r.threshold > currentTotal);
    const achievedRewards = rewards.filter(r => r.threshold <= currentTotal);

    // Remove reward products that no longer qualify (skip if already processing removal)
    if (!skipRewardRemoval) {
      const removedItems = await this.#removeUnqualifiedRewards(currentTotal, rewards);
      
      // If items were removed, refresh cart
      if (removedItems > 0) {
        // Fetch updated cart and re-render
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        
        // Update cart state
        const updatedParsedState = {
          item_count: cart.item_count,
          total_price: cart.total_price,
          items: cart.items
        };
        
        // Check if cart is now empty (only reward items or completely empty)
        const realItemCount = cart.items.filter(item => {
          return !(item.properties && (
            item.properties._reward === 'true' || 
            item.properties._gift === 'true'
          ));
        }).length;
        
        if (realItemCount === 0) {
          // Cart is empty or only has reward items - refresh the drawer to show empty state
          this.renderContents(updatedParsedState);
          return;
        }
        
        // Just update the cart view without triggering progress bar update
        // The progress bar will be updated by the ongoing updateProgressBar call
        await this.updateCartNotificationProduct();
        
        // Update cart count in header
        this.#updateCartNotificationCount(cart.item_count || 0);
        this.#updateCartHeaderCount(cart.item_count || 0);
        // Update cart total (exclude reward/gift items)
        this.#updateCartTotal(cart);
      }
    }

    // Update reward visual states (add/remove achieved class)
    const rewardElements = progressContainer.querySelectorAll('.free-shipping-reward');
    const achievedTextMode = progressContainer.dataset.achievedTextMode || 'last';
    const showRewardTitles = progressContainer.dataset.showRewardTitles !== 'false';
    
    for (const rewardElement of rewardElements) {
      const rewardThreshold = parseInt(rewardElement.dataset.threshold) || 0;
      const rewardText = rewardElement.querySelector('.free-shipping-reward__text');
      const isAchieved = rewardThreshold <= currentTotal && rewardThreshold > 0;
      
      if (isAchieved) {
        rewardElement.classList.add('achieved');
        
        // Show/hide text based on mode and settings
        if (!showRewardTitles) {
          // Hide all reward titles if setting is disabled
          if (rewardText) rewardText.style.display = 'none';
        } else if (achievedTextMode === 'all') {
          // Show text for all achieved rewards
          if (rewardText) rewardText.style.display = '';
        } else if (achievedTextMode === 'last') {
          // Show text only for the last (highest) achieved reward
          const isLastAchieved = achievedRewards.length > 0 && 
            rewardThreshold === Math.max(...achievedRewards.map(r => r.threshold));
          if (rewardText) {
            rewardText.style.display = isLastAchieved ? '' : 'none';
          }
        } else {
          // Hide text for all achieved rewards
          if (rewardText) rewardText.style.display = 'none';
        }
      } else {
        rewardElement.classList.remove('achieved');
        // Show text for non-achieved rewards (if setting allows)
        if (rewardText) {
          rewardText.style.display = showRewardTitles ? '' : 'none';
        }
      }
    }

    // Update message - always show all achieved rewards, one per line
    let messageHTML = '';
    
    if (achievedRewards.length > 0) {
      // Show all achieved rewards text, one per line
      // Use data-reward-text attribute from DOM for reliable text retrieval
      const achievedTexts = achievedRewards.map(reward => {
        // Get text from data attribute (always available regardless of display settings)
        const text = reward.element?.dataset?.rewardText || '';
        console.log(`✅ Reward ${reward.type} (${reward.threshold}): "${text}"`);
        return text;
      }).filter(text => text !== '');
      
      if (achievedTexts.length > 0) {
        // Show each achieved reward on a separate line
        messageHTML = achievedTexts.map(text => `<p class="reward_earned_text">✓ ${text}</p>`).join('');
        console.log('✅ Achieved rewards list HTML:', messageHTML);
        console.log('✅ Achieved rewards texts:', achievedTexts);
      } else {
        console.log('⚠️ No achieved texts found despite achievedRewards.length:', achievedRewards.length);
        console.log('⚠️ achievedRewards full:', JSON.stringify(achievedRewards, null, 2));
        // Try to access first reward details
        if (achievedRewards[0]) {
          console.log('⚠️ First reward has element?', !!achievedRewards[0].element);
          console.log('⚠️ First reward object:', achievedRewards[0]);
        }
      }
      
      // Add/remove free shipping item based on achieved rewards (async, non-blocking)
      setTimeout(() => {
        this.#updateFreeShippingCartItem(achievedRewards);
      }, 150);
    } else {
      // No achieved rewards - make sure free shipping item is removed
      setTimeout(() => {
        const existingFreeShippingItem = document.querySelector('[data-reward-type="free_shipping"]');
        if (existingFreeShippingItem) {
          console.log('🚚 Removing free shipping cart item (no rewards achieved)');
          existingFreeShippingItem.remove();
        }
      }, 150);
    }
    
    // Add next reward message if there is one
    if (nextReward) {
      const remaining = nextReward.threshold - currentTotal;
      const remainingFormatted = this.#formatMoney(remaining);
      messageHTML += `<p>${this.#getProgressMessage(remainingFormatted, nextReward)}</p>`;
    } else if (achievedRewards.length > 0) {
      // All rewards achieved, add success message if not already shown
      if (!messageHTML || !messageHTML.includes('message-success')) {
        messageHTML += `<p class="message-success">🎉 ${this.#getSuccessMessage()}</p>`;
      }
    }
    
    // Always set message HTML, even if empty
    if (messageElement) {
      messageElement.innerHTML = messageHTML || '';
      console.log('📝 Progress bar message set. Length:', messageHTML.length, 'HTML:', messageHTML.substring(0, 200));
    } else {
      console.warn('Message element not found for progress bar');
    }

    // Handle reward application - apply rewards AFTER visual updates
    // This prevents infinite loops
    if (achievedRewards.length > 0 && !skipRewardRemoval && !this.isApplyingRewards) {
      this.isApplyingRewards = true;
      
      // Apply rewards asynchronously without blocking UI updates
      this.#applyRewards(achievedRewards, rewardMode, currentTotal).then(() => {
        // Rewards applied, reset flag
        // Cart drawer will be updated automatically by Shopify's cart update mechanism
        this.isApplyingRewards = false;
      }).catch(error => {
        console.error('Error applying rewards:', error);
        this.isApplyingRewards = false;
      });
    }
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.remove("no-js-inline");
    } else {
      document
        .getElementById(`Line-item-error-${line}`)
        .classList.add("no-js-inline");
    }
    this.currentItemCount = itemCount;
  }

  async deleteQuantity(line, quantity, name) {
    // Prevent removing reward items - check both DOM and cart API
    const removeButton = document.getElementById(`Remove-${line}`);
    if (removeButton) {
      const cartItem = removeButton.closest('.cart-notification-product');
      if (cartItem && cartItem.classList.contains('cart-item--reward')) {
        // Don't allow removing reward items
        return;
      }
    }
    
    // Also verify from cart API if this is a reward item
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item by line number (1-based index)
      const itemIndex = parseInt(line) - 1;
      if (itemIndex >= 0 && itemIndex < cart.items.length) {
        const item = cart.items[itemIndex];
        const isReward = item.properties && (
          item.properties._reward === 'true' || 
          item.properties._gift === 'true'
        );
        
        if (isReward) {
          // This is a reward item, prevent removal
          console.log('Prevented removal of reward item');
          return;
        }
      }
    } catch (error) {
      console.error('Error checking cart for reward item:', error);
      // If check fails, continue with normal flow
    }
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    
    const fetchOptions = { ...fetchConfig(), ...{ body } };
    // Add headers to prevent redirects and ensure JSON response
    fetchOptions.headers = {
      ...fetchOptions.headers,
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    };
    fetchOptions.redirect = 'manual';
    
    fetch(`${routes.cart_change_url}`, fetchOptions)
      .then((response) => {
        // Check if response is JSON
        const contentType = response.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) {
          // If not JSON, it might be HTML (redirect)
          return response.text().then(text => {
            if (text.includes('<!DOCTYPE') || text.includes('<html')) {
              console.error('Cart change request resulted in HTML redirect');
              throw new Error('HTML redirect detected');
            }
            // Try to parse as JSON anyway
            return JSON.parse(text);
          });
        }
        return response.text();
      })
      .then((state) => {
        let parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        
        // Ensure reward items have quantity 1
        this.#ensureRewardItemsQuantity(parsedState);
        
        // Update cart header count
        this.#updateCartHeaderCount(parsedState.item_count || 0);
        // Update cart notification count in header
        this.#updateCartNotificationCount(parsedState.item_count || 0);
        // Update cart total (exclude reward/gift items)
        this.#updateCartTotal(parsedState);
        // Update progress bar after cart change
        this.updateProgressBar(parsedState);
      })
      .catch((error) => {
        console.error('Error deleting item from cart:', error);
      })
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
		this.notification.classList.remove('loading-bar');
      });
  }

  async #ensureRewardItemsQuantity(parsedState) {
    // Check cart for reward items and ensure they have quantity 1
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      for (const item of cart.items) {
        const isReward = item.properties && (
          item.properties._reward === 'true' || 
          item.properties._gift === 'true'
        );
        
        if (isReward && item.quantity !== 1) {
          // Update quantity to 1
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.key,
              quantity: 1
            })
          });
        }
      }
    } catch (error) {
      console.error('Error ensuring reward items quantity:', error);
    }
  }

  async #removeUnqualifiedRewards(currentTotal, rewards) {
    // Prevent concurrent removal operations
    if (this.isRemovingRewards) {
      console.log('🗑️ Already removing rewards, skipping duplicate call');
      return;
    }
    
    this.isRemovingRewards = true;
    console.log('🗑️ Starting reward removal process');
    
    let removedCount = 0;
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Get all reward items from cart - ensure properties have reward defined
      const rewardItems = cart.items.filter(item => {
        // Must have properties and must have _reward or _gift property set to 'true'
        if (!item.properties) {
          return false;
        }
        const hasReward = item.properties._reward === 'true';
        const hasGift = item.properties._gift === 'true';
        return hasReward || hasGift;
      });
      
      console.log('🗑️ #removeUnqualifiedRewards - Cart items:', cart.items.length);
      console.log('🗑️ Reward items found:', rewardItems.length, rewardItems.map(i => ({
        key: i.key,
        handle: i.product_handle,
        title: i.title,
        hasReward: i.properties?._reward,
        hasGift: i.properties?._gift
      })));
      console.log('🗑️ Non-reward items:', cart.items.filter(item => {
        if (!item.properties) return true;
        const hasReward = item.properties._reward === 'true';
        const hasGift = item.properties._gift === 'true';
        return !(hasReward || hasGift);
      }).map(i => ({ key: i.key, handle: i.product_handle, title: i.title })));
      
      // Check each reward item against current cart total
      // Process rewards one at a time and refresh cart after each removal to avoid line number issues
      let currentCart = cart;
      
      // Create a copy of reward items to iterate, but we'll check against currentCart
      const rewardItemsToCheck = [...rewardItems];
      
      // First pass: identify which rewards need to be removed
      const itemsToRemove = [];
      
      for (let i = 0; i < rewardItemsToCheck.length; i++) {
        const item = rewardItemsToCheck[i];
        
        // Calculate current total WITHOUT reward items for accurate threshold check
        const totalWithoutRewards = cart.items
          .filter(cartItem => {
            if (!cartItem.properties) return true;
            const hasReward = cartItem.properties._reward === 'true';
            const hasGift = cartItem.properties._gift === 'true';
            return !(hasReward || hasGift);
          })
          .reduce((sum, cartItem) => sum + cartItem.final_line_price, 0);
        
        // Get threshold from item properties
        const itemThreshold = item.properties?._reward_threshold 
          ? parseInt(item.properties._reward_threshold) 
          : null;
        
        // If threshold is not in properties, try to find matching reward from config
        let rewardThreshold = itemThreshold;
        if (!rewardThreshold) {
          const matchingReward = rewards.find(reward => {
            if (reward.type === 'gift_product' && reward.value) {
              const isVariantId = /^\d+$/.test(reward.value);
              if (isVariantId) {
                return item.variant_id.toString() === reward.value.toString();
              } else {
                const itemHandle = item.product_handle || item.handle;
                return itemHandle === reward.value;
              }
            }
            return false;
          });
          
          if (matchingReward) {
            rewardThreshold = matchingReward.threshold;
          }
        }
        
        // Skip if no threshold found
        if (!rewardThreshold || rewardThreshold <= 0) {
          console.warn('Reward item has no threshold, skipping removal check:', item);
          continue;
        }
        
        // Check if this reward should be removed
        const shouldRemove = totalWithoutRewards < rewardThreshold;
        
        console.log('Threshold check for reward:', {
          rewardThreshold,
          totalWithoutRewards,
          shouldRemove,
          itemKey: item.key,
          productHandle: item.product_handle || item.handle
        });
        
        if (shouldRemove) {
          itemsToRemove.push({
            item,
            threshold: rewardThreshold
          });
        }
      }
      
      console.log('Total items to remove:', itemsToRemove.length, 'out of', rewardItemsToCheck.length, 'reward items');
      console.log('🗑️ Items marked for removal:', itemsToRemove.map(i => ({
        key: i.item.key,
        handle: i.item.product_handle,
        title: i.item.title,
        threshold: i.threshold
      })));
      
      // Second pass: remove only the items that were marked for removal
      for (let i = 0; i < itemsToRemove.length; i++) {
        // Refresh cart at the start of each iteration to ensure we have the latest state
        const freshCartResponse = await fetch('/cart.js');
        currentCart = await freshCartResponse.json();
        
        const itemToRemove = itemsToRemove[i];
        
        // Double-check: Make sure this is still a reward item in the current cart
        const currentItem = currentCart.items.find(cartItem => cartItem.key === itemToRemove.item.key);
        if (!currentItem) {
          // Item already removed, skip
          continue;
        }
        
        // Verify it's still a reward item - must have properties with _reward or _gift
        if (!currentItem.properties) {
          console.warn('Item has no properties during removal, skipping:', currentItem);
          continue;
        }
        
        const hasReward = currentItem.properties._reward === 'true';
        const hasGift = currentItem.properties._gift === 'true';
        const isRewardItem = hasReward || hasGift;
        
        if (!isRewardItem) {
          // Not a reward item, skip (should not happen, but safety check)
          console.warn('Item is not a reward item during removal, skipping:', currentItem);
          continue;
        }
        
        // Find the line number (1-based index) of this item in the current cart
        const itemIndex = currentCart.items.findIndex(cartItem => cartItem.key === currentItem.key);
        
        if (itemIndex === -1) {
          // Item not found in cart, might have been already removed
          console.warn('Reward item not found during removal, might have been already removed:', currentItem);
          continue;
        }
        
        // Verify line number is valid (must be between 1 and items.length)
        if (itemIndex < 0 || itemIndex >= currentCart.items.length) {
          console.error('Invalid item index during removal:', itemIndex, 'Cart items length:', currentCart.items.length);
          continue;
        }
        
        // Line number is 1-based index
        const lineNumber = itemIndex + 1;
        
        // Double-check: verify the item at this line number is the reward item
        const itemAtLine = currentCart.items[itemIndex];
        if (!itemAtLine || itemAtLine.key !== currentItem.key) {
          console.error('Item mismatch at line number during removal:', lineNumber, 'Expected:', currentItem.key, 'Found:', itemAtLine?.key);
          continue;
        }
        
        // TRIPLE-CHECK: Verify this is still a reward item before removing
        const finalCheckItem = currentCart.items[itemIndex];
        if (!finalCheckItem.properties) {
          console.error('Item has no properties before removal, skipping to prevent removing normal product:', finalCheckItem);
          continue;
        }
        
        const finalHasReward = finalCheckItem.properties._reward === 'true';
        const finalHasGift = finalCheckItem.properties._gift === 'true';
        if (!finalHasReward && !finalHasGift) {
          console.error('CRITICAL: Attempted to remove non-reward item! Skipping to prevent data loss:', finalCheckItem);
          continue;
        }
        
        try {
          // Use line number for removal
          const changeBody = { line: lineNumber, quantity: 0 };
          
          console.log('Actually removing reward item:', {
            itemKey: currentItem.key,
            variantId: currentItem.variant_id,
            itemIndex,
            lineNumber,
            cartItemsLength: currentCart.items.length,
            threshold: itemToRemove.threshold
          });
          
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            },
            redirect: 'manual', // Prevent automatic redirects
            body: JSON.stringify(changeBody)
          });
          
          if (!response.ok) {
            const errorText = await response.text();
            console.error('Error removing reward item:', response.status, errorText, changeBody);
            // Try to continue with next item even if this one failed
            continue;
          } else {
            // Check if response is JSON (not HTML redirect)
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json')) {
              removedCount++;
              
              // IMPORTANT: Refresh cart after each removal to get updated line numbers
              const updatedCartResponse = await fetch('/cart.js');
              currentCart = await updatedCartResponse.json();
              
              // Check if cart is now empty (only reward items or completely empty)
              const realItemCount = currentCart.items.filter(item => {
                return !(item.properties && (
                  item.properties._reward === 'true' || 
                  item.properties._gift === 'true'
                ));
              }).length;
              
              if (realItemCount === 0) {
                // Cart is empty or only has reward items - refresh the drawer to show empty state
                const emptyParsedState = {
                  item_count: currentCart.item_count,
                  total_price: currentCart.total_price,
                  items: currentCart.items,
                  sections: {}
                };
                this.renderContents(emptyParsedState);
                // Break the loop since cart is now empty
                break;
              }
              // Don't call updateCartNotificationProduct here - it will be called after all removals
            } else {
              // If response is HTML, it's a redirect - don't process it
              const responseText = await response.text();
              if (responseText.includes('<!DOCTYPE') || responseText.includes('<html')) {
                console.error('Cart change request resulted in HTML redirect when removing reward');
              } else {
                // Try to parse as JSON anyway
                try {
                  JSON.parse(responseText);
                  removedCount++;
                  
                  // IMPORTANT: Refresh cart after each removal to get updated line numbers
                  const updatedCartResponse = await fetch('/cart.js');
                  currentCart = await updatedCartResponse.json();
                  
                  const realItemCount = currentCart.items.filter(item => {
                    return !(item.properties && (
                      item.properties._reward === 'true' || 
                      item.properties._gift === 'true'
                    ));
                  }).length;
                  
                  if (realItemCount === 0) {
                    // Cart is empty or only has reward items - refresh the drawer to show empty state
                    const emptyParsedState = {
                      item_count: currentCart.item_count,
                      total_price: currentCart.total_price,
                      items: currentCart.items,
                      sections: {}
                    };
                    this.renderContents(emptyParsedState);
                    // Break the loop since cart is now empty
                    break;
                  }
                  // Don't call updateCartNotificationProduct here - it will be called after all removals
                } catch (e) {
                  console.error('Could not parse response as JSON:', e);
                }
              }
            }
          }
        } catch (error) {
          console.error('Error removing unqualified reward:', error, itemToRemove);
        }
      }
    } catch (error) {
      console.error('Error removing unqualified rewards:', error);
    } finally {
      // Always reset flag when done
      this.isRemovingRewards = false;
      console.log('🗑️ Reward removal process completed');
    }
    
    // After all removals, update cart view if any items were removed
    if (removedCount > 0) {
      await this.updateCartNotificationProduct();
      
      // Update cart count in header
      const finalCartResponse = await fetch('/cart.js');
      const finalCart = await finalCartResponse.json();
      this.#updateCartNotificationCount(finalCart.item_count || 0);
      this.#updateCartHeaderCount(finalCart.item_count || 0);
      await this.#updateCartTotal(finalCart);
    }
    
    return removedCount;
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    if (!html) return null;
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const element = doc.querySelector(selector);
    
    if (!element) {
      // If shopify-section not found, try to find the section by ID or return the body content
      const bodyContent = doc.body;
      if (bodyContent && bodyContent.children.length > 0) {
        return bodyContent.innerHTML;
      }
      return null;
    }
    
    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.miniCartClose()
      );
    }
  }

  onClickMiniCart() {
    const notification = document.getElementById("offcanvas__mini_cart");
    if (!notification) {
      console.warn('Cart notification element not found');
      return;
    }

    notification.classList.add("animate", "active");
    
    const body = document.querySelector("body");
    if (body) {
      body.classList.add("added__overlay");
    }

    this.notification.addEventListener(
      "transitionend",
      () => {
        if (this.notification) {
          this.notification.focus();
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    if (document.body) {
      document.body.addEventListener("click", this.onBodyClassRemove);
    }

    // Fetch cart state and update progress bar when drawer is opened
    this.#updateCartOnDrawerOpen();
  }

  async #updateCartOnDrawerOpen() {
    try {
      // Wait 2 seconds after drawer opens before updating progress bar
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Find CartNotification instance
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification && cartNotification.updateProgressBar) {
        // Create parsedState-like object
        const parsedState = {
          item_count: cart.item_count || 0,
          total_price: cart.total_price || 0,
          items: cart.items || []
        };
        
        // Update progress bar with current cart state
        cartNotification.updateProgressBar(parsedState);
      }
    } catch (error) {
      console.error('Error fetching cart state on drawer open:', error);
    }
  }

  miniCartClose() {
    const notification = document.getElementById("offcanvas__mini_cart");
    if (notification) {
      notification.classList.remove("active");
    }
    
    const body = document.querySelector("body");
    if (body) {
      body.classList.remove("added__overlay");
    }

    if (document.body) {
      document.body.removeEventListener("click", this.onBodyClassRemove);
    }
    
    const cartButton = document.querySelector(".header__actions_btn--cart");
    if (cartButton) {
      removeTrapFocus(cartButton);
    }
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    //console.log(eventTarget);
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);
